import { Edit, SimpleForm } from 'react-admin'
import { UpsertSupplier } from '~/components'

export const SupplierEdit = (props) => {
  return (
    <Edit mutationMode='undoable' {...props} redirect='show'>
      <SimpleForm warnWhenUnsavedChanges>
        <UpsertSupplier {...props} />
      </SimpleForm>
    </Edit>
  )
}

export default SupplierEdit
